// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "whatsapp_account".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { tokenStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "whatsapp_account" table (1:1 with a DB row, on the wire). */
export const whatsappAccountAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    connectedById: z.string(),
    phoneNumberId: z.string(),
    wabaId: z.string(),
    phoneNumber: z.string(),
    displayName: z.string().nullable(),
    isActive: z.boolean(),
    isVerified: z.boolean(),
    isChatbotActive: z.boolean(),
    encryptedCredentials: z.string(),
    tokenExpiresAt: z.string().datetime().nullable(),
    tokenStatus: z.enum(tokenStatusValues),
    lastSyncAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=whatsappAccount.js.map